export default __webpack_public_path__ + "static/media/AcornMallCarpark_29.34ee1876.png";